export default __webpack_public_path__ + "static/media/plane3.7c1ed831.jpg";